import * as React from 'react';

export { React };
